// @generated
// This file is automatically generated by Kanel. Do not modify manually.

import { readerId, type ReaderId } from './Reader';
import type { ColumnType, Selectable, Insertable, Updateable } from 'kysely';
import { z } from 'zod';

/** Identifier type for public.mqtt_event */
export type MqttEventId = string & { __brand: 'public.mqtt_event' };

/** Represents the table public.mqtt_event */
export default interface MqttEventTable {
  id: ColumnType<MqttEventId, MqttEventId | undefined, MqttEventId>;

  reader_id: ColumnType<ReaderId, ReaderId, ReaderId>;

  payload: ColumnType<unknown, unknown, unknown>;

  _created_at: ColumnType<string, string | undefined, string>;
}

export type MqttEvent = Selectable<MqttEventTable>;

export type NewMqttEvent = Insertable<MqttEventTable>;

export type MqttEventUpdate = Updateable<MqttEventTable>;

export const mqttEventId = z.string() as unknown as z.Schema<MqttEventId>;

export const mqttEvent = z.object({
  id: mqttEventId,
  reader_id: readerId,
  payload: z.unknown(),
  _created_at: z.string(),
}) as unknown as z.Schema<MqttEvent>;

export const mqttEventInitializer = z.object({
  id: mqttEventId.optional(),
  reader_id: readerId,
  payload: z.unknown(),
}) as unknown as z.Schema<MqttEventInitializer>;

export const mqttEventMutator = z.object({
  id: mqttEventId.optional(),
  reader_id: readerId.optional(),
  payload: z.unknown().optional(),
}) as unknown as z.Schema<MqttEventMutator>;
